import React from "react";
import Dropdown from "../../../Components/Dropdown/RealTimeButtonDropDown/DropDown";
import Switch from "../../SelectionControls/Switch/Switch";
import style from "../variantList.module.scss"


const variantFilters = (props) => {

    let allVariantFilters = [
        { label: 'وضعیت فروش', tag: "salesStatus", dropdownList: [{ name: "وضعیت فروش فعال", checked: props.getFromUrl("salesStatus") === "both" || props.getFromUrl("salesStatus") === true ? true : false }, { name: "وضعیت فروش غیرفعال", checked: props.getFromUrl("salesStatus") === "both" || props.getFromUrl("salesStatus") === false ? true : false }], hasToggle: true, hasSearchBox: false, hasCheckbox: false },
        { label: 'گروه کالا', tag: "productGroup", dropdownList: props.searcher(props.filterData.productGroups, props.filterData.productGroup), hasToggle: false, hasSearchBox: true, hasCheckbox: true },
        { label: 'برند', tag: "brand", dropdownList: props.searcher(props.filterData.brands, props.filterData.brand), hasToggle: false, hasSearchBox: true, hasCheckbox: true },
        { label: 'رقابت', tag: 'hasComp', dropdownList: [{ name: "تنوع‌های دارای رقیب", checked: props.getFromUrl("hasComp") === "both" || props.getFromUrl("hasComp") === true ? true : false }, { name: "تنوع‌های بدون رقیب", checked: props.getFromUrl("hasComp") === "both" || props.getFromUrl("hasComp") === false ? true : false }], hasToggle: true, hasSearchBox: false, hasCheckbox: false },
        { label: 'فروشنده', tag: "channel", dropdownList: props.searcher(props.filterData.channels, props.filterData.channel), hasToggle: false, hasSearchBox: true, hasCheckbox: true },
    ]

    return (
        <React.Fragment>
            <div className={style.dropdownWrapper}>
                {props.checkUrl() ? <div className={style.deleteAll} onClick={() => props.deleteAllFiletrs()}>
                    <span className={style.icon}>g</span>
                </div> : null}
                {allVariantFilters.map((filter, filterIndex) => <div key={filterIndex} className={style.dropdownBox}>
                    {filter.tag !== 'channel' && <Dropdown
                        tag={filter.tag}
                        label={filter.label}
                        placeHolder={filter.label}
                        dropdownList={filter.dropdownList}
                        hasToggle={filter.hasToggle}
                        hasSearchBox={filter.hasSearchBox}
                        hasCheckbox={filter.hasCheckbox}
                        handleSearch={props.searchHandler}
                        deleteSelectedItems={props.deleteFromUrl}
                        handleSelect={filter.hasToggle ? props.sellStatusHandler : props.selectHandler}
                        action={props.getVariants}
                    />}
                    {filter.tag == 'channel' && props.filterData.channels.length > 1 && <Dropdown
                        tag={filter.tag}
                        label={filter.label}
                        placeHolder={filter.label}
                        dropdownList={filter.dropdownList}
                        hasToggle={filter.hasToggle}
                        hasSearchBox={filter.hasSearchBox}
                        hasCheckbox={filter.hasCheckbox}
                        handleSearch={props.searchHandler}
                        deleteSelectedItems={props.deleteFromUrl}
                        handleSelect={filter.hasToggle ? props.sellStatusHandler : props.selectHandler}
                        action={props.getVariants}
                    />}
                </div>)}

                <div className={style.incompleteProducts}>
                    <Switch
                        value={props.getFromUrl("incompleteProducts")}
                        indeterminate={false}
                        disabled={false}
                        tag='incompleteProducts'
                        label='کالاهای تکمیل نشده در ربات'
                        onclick={(e, val, tag) => {
                            props.setToUrl(!val, tag)
                        }} />
                </div>
            </div>
        </React.Fragment>
    );
}

export default variantFilters;
